@if (showEditMode) {
    <cerrix-textfield
        #cerrixInput
        class="edit-text-input"
        [(ngModel)]="value"
        [required]="required"
        [placeholder]="placeholder"
        (blurEvent)="onBlur()"
    ></cerrix-textfield>
} @else {
    <span [title]="value" class="edit-text-result text-truncate">{{ value }}</span>
    @if (!disabled) {
        <i
            class="edit-text-button fal fa-edit"
            (click)="enableEditMode()"
            [title]="editButtonText"
        ></i>
    }
}
